var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Rect, Circle, Ellipse, Line, Group, Text, Arrow } from "react-konva";
import { useSelector } from "react-redux";
import { setEraserTrash, setSelectedItem, cancelSelectedItem, resaveShape, getCurrentScene } from "../../../../../../../redux/actions/canvas/canvas";
import { addCommand } from "../../../../../../../services/history/HistoryService";
export var CanvasShape = function (_a) {
    var shape = _a.shape;
    var _b = useSelector(function (state) { return state; }).canvas, instrument = _b.instrument, isPressed = _b.isPressed, eraserTrashCan = _b.eraserTrashCan, selectedItem = _b.selectedItem;
    var setTrashedItem = function (id) {
        if (!eraserTrashCan.includes(id)) {
            setEraserTrash(__spreadArray(__spreadArray([], __read(eraserTrashCan), false), [id], false));
        }
    };
    var onShapeClick = function (event, selectedItemId, itemId, isGroup) {
        if (isGroup === void 0) { isGroup = false; }
        if (!['cursor', 'shapes'].includes(instrument))
            return;
        event.currentTarget.moveToTop();
        if (itemId === selectedItemId)
            return cancelSelectedItem();
        // Для Group используем currentTarget, для остальных фигур - target
        setSelectedItem({ type: 'shape', id: itemId, ref: isGroup ? event.currentTarget : event.target });
    };
    var onShapeDragEnd = function (event) {
        var scene = getCurrentScene();
        var oldShape = scene === null || scene === void 0 ? void 0 : scene.shapes.find(function (s) { return s.id === shape.id; });
        if (oldShape) {
            addCommand('MOVE_SHAPE', {
                id: shape.id,
                oldX: oldShape.x || 0,
                oldY: oldShape.y || 0
            });
        }
        var x = event.target.x();
        var y = event.target.y();
        resaveShape(shape.id, x, y);
        cancelSelectedItem();
    };
    var onShapeTransformEnd = function (event) {
        var scene = getCurrentScene();
        var oldShape = scene === null || scene === void 0 ? void 0 : scene.shapes.find(function (s) { return s.id === shape.id; });
        if (oldShape) {
            addCommand('TRANSFORM_SHAPE', {
                id: shape.id,
                oldRotation: oldShape.rotation || 0,
                oldScaleX: oldShape.scaleX || 1,
                oldScaleY: oldShape.scaleY || 1
            });
        }
        var x = event.target.x();
        var y = event.target.y();
        var rotation = event.target.rotation();
        var scaleX = event.target.scaleX();
        var scaleY = event.target.scaleY();
        resaveShape(shape.id, x, y, rotation, scaleX, scaleY);
        cancelSelectedItem();
    };
    var commonProps = __assign({ opacity: eraserTrashCan.includes(shape.id) ? 0.4 : 1, onPointerOver: instrument === 'eraser' && isPressed ? function () { return setTrashedItem(shape.id); } : undefined, onPointerClick: function (event) { return onShapeClick(event, selectedItem ? selectedItem.id : '', shape.id); }, draggable: ['cursor', 'shapes'].includes(instrument) && (selectedItem && selectedItem.id === shape.id), onDragEnd: onShapeDragEnd, onTransformEnd: onShapeTransformEnd, rotation: shape.rotation || 0, scaleX: shape.scaleX || 1, scaleY: shape.scaleY || 1 }, shape.attr);
    switch (shape.shapeType) {
        case 'rectangle': {
            var _c = __read(shape.points, 4), rectX = _c[0], rectY = _c[1], width = _c[2], height = _c[3];
            return (_jsx(Rect, __assign({}, commonProps, { x: shape.x !== undefined ? shape.x : rectX, y: shape.y !== undefined ? shape.y : rectY, width: width, height: height })));
        }
        case 'circle': {
            var _d = __read(shape.points, 4), centerX = _d[0], centerY = _d[1], radiusX = _d[2], radiusY = _d[3];
            if (radiusX === radiusY) {
                return (_jsx(Circle, __assign({}, commonProps, { x: shape.x !== undefined ? shape.x : centerX, y: shape.y !== undefined ? shape.y : centerY, radius: radiusX })));
            }
            else {
                return (_jsx(Ellipse, __assign({}, commonProps, { x: shape.x !== undefined ? shape.x : centerX, y: shape.y !== undefined ? shape.y : centerY, radiusX: radiusX, radiusY: radiusY })));
            }
        }
        case 'triangle':
        case 'triangle-custom':
        case 'trapezoid':
        case 'rhombus':
        case 'parallelogram': {
            return (_jsx(Line, __assign({}, commonProps, { x: shape.x || 0, y: shape.y || 0, points: shape.points, closed: true })));
        }
        case 'coordinate-system': {
            var _e = __read(shape.points, 3), centerX = _e[0], centerY = _e[1], size = _e[2];
            var x = shape.x !== undefined ? shape.x : centerX;
            var y = shape.y !== undefined ? shape.y : centerY;
            // Специальные props для Group (используем currentTarget вместо target)
            var groupProps = {
                opacity: eraserTrashCan.includes(shape.id) ? 0.4 : 1,
                onPointerOver: instrument === 'eraser' && isPressed ? function () { return setTrashedItem(shape.id); } : undefined,
                onPointerClick: function (event) { return onShapeClick(event, selectedItem ? selectedItem.id : '', shape.id, true); },
                draggable: ['cursor', 'shapes'].includes(instrument) && (selectedItem && selectedItem.id === shape.id),
                onDragEnd: onShapeDragEnd,
                onTransformEnd: onShapeTransformEnd,
                rotation: shape.rotation || 0,
                scaleX: shape.scaleX || 1,
                scaleY: shape.scaleY || 1,
            };
            return (_jsxs(Group, __assign({}, groupProps, { x: x, y: y }, { children: [_jsx(Arrow, { points: [-size, 0, size, 0], stroke: shape.attr.stroke, strokeWidth: shape.attr.strokeWidth, fill: shape.attr.stroke, pointerLength: 10, pointerWidth: 10, dash: shape.attr.dash, hitStrokeWidth: 20 }), _jsx(Arrow, { points: [0, size, 0, -size], stroke: shape.attr.stroke, strokeWidth: shape.attr.strokeWidth, fill: shape.attr.stroke, pointerLength: 10, pointerWidth: 10, dash: shape.attr.dash, hitStrokeWidth: 20 }), _jsx(Text, { text: "0", x: -20, y: 5, fontSize: 16, fill: shape.attr.stroke, fontFamily: "Arial" })] })));
        }
        case 'parallelepiped': {
            var _f = __read(shape.points, 6), startX = _f[0], startY = _f[1], width = _f[2], height = _f[3], offsetX = _f[4], offsetY = _f[5];
            var x = shape.x || 0;
            var y = shape.y || 0;
            // Специальные props для Group
            var groupProps = {
                opacity: eraserTrashCan.includes(shape.id) ? 0.4 : 1,
                onPointerOver: instrument === 'eraser' && isPressed ? function () { return setTrashedItem(shape.id); } : undefined,
                onPointerClick: function (event) { return onShapeClick(event, selectedItem ? selectedItem.id : '', shape.id, true); },
                draggable: ['cursor', 'shapes'].includes(instrument) && (selectedItem && selectedItem.id === shape.id),
                onDragEnd: onShapeDragEnd,
                onTransformEnd: onShapeTransformEnd,
                rotation: shape.rotation || 0,
                scaleX: shape.scaleX || 1,
                scaleY: shape.scaleY || 1,
            };
            return (_jsxs(Group, __assign({}, groupProps, { x: x, y: y }, { children: [_jsx(Line, { points: [
                            startX, startY,
                            startX + width, startY,
                            startX + width, startY + height,
                            startX, startY + height
                        ], stroke: shape.attr.stroke, strokeWidth: shape.attr.strokeWidth, fill: shape.attr.fill, dash: shape.attr.dash, closed: true }), _jsx(Line, { points: [
                            startX + offsetX, startY - offsetY,
                            startX + width + offsetX, startY - offsetY,
                            startX + width + offsetX, startY + height - offsetY,
                            startX + offsetX, startY + height - offsetY
                        ], stroke: shape.attr.stroke, strokeWidth: shape.attr.strokeWidth, fill: shape.attr.fill, dash: shape.attr.dash, closed: true }), _jsx(Line, { points: [startX, startY, startX + offsetX, startY - offsetY], stroke: shape.attr.stroke, strokeWidth: shape.attr.strokeWidth, dash: shape.attr.dash }), _jsx(Line, { points: [startX + width, startY, startX + width + offsetX, startY - offsetY], stroke: shape.attr.stroke, strokeWidth: shape.attr.strokeWidth, dash: shape.attr.dash }), _jsx(Line, { points: [startX + width, startY + height, startX + width + offsetX, startY + height - offsetY], stroke: shape.attr.stroke, strokeWidth: shape.attr.strokeWidth, dash: shape.attr.dash }), _jsx(Line, { points: [startX, startY + height, startX + offsetX, startY + height - offsetY], stroke: shape.attr.stroke, strokeWidth: shape.attr.strokeWidth, dash: shape.attr.dash })] })));
        }
        default:
            return null;
    }
};
